
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/services",
      function () {
        return require("private-next-pages/info/services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/services"])
      });
    }
  